// extracted by mini-css-extract-plugin
module.exports = {"container":"level-tabs_container__1K3bs","level":"level-tabs_level__2-xW7","active":"level-tabs_active__1cQSF","inactive":"level-tabs_inactive__2eb08"};